import { useState } from "react";
import { ArrowRight, BadgeCheck, Factory, ShieldCheck, X } from "lucide-react";
import { useQuote } from "../../context/QuoteContext";

const KEY = "mlfab_alert_closed";

export function TopAlert() {
  const [open, setOpen] = useState(() => sessionStorage.getItem(KEY) !== "1");
  const { openQuote } = useQuote();
  if (!open) return null;
  const close = () => { sessionStorage.setItem(KEY, "1"); setOpen(false); };
  return (
    <div className="alert-bar" data-testid="top-alert-bar">
      <div className="wrap alert-inner">
        <div className="alert-badges">
          <span><ShieldCheck size={14} /> GeM Registered OEM</span>
          <span><BadgeCheck size={14} /> ISO 9001:2015 Certified</span>
          <span className="hide-sm"><Factory size={14} /> Make in India Manufacturer</span>
        </div>
        <button className="alert-cta" onClick={() => openQuote({ variant: "tender", source: "top-alert" })} data-testid="top-alert-tender-cta">
          Now accepting FY 2026-27 tender enquiries <ArrowRight size={13} />
        </button>
        <button className="alert-close" onClick={close} aria-label="Dismiss" data-testid="top-alert-dismiss"><X size={14} /></button>
      </div>
    </div>
  );
}
